var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 30.5C2.5 15.312 14.812 3 30 3h40c15.188 0 27.5 12.312 27.5 27.5v40C97.5 85.688 85.188 98 70 98H30C14.812 98 2.5 85.688 2.5 70.5v-40z",
    stroke: "#F9B035",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 32,
    width: 46,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.504 32.504h-45v36h45v-36z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.004 32.504c1.924 0 3.897.05 5.81.13l2.258.108 2.163.129 2.025.137 1.85.144a8.554 8.554 0 017.86 7.702l.09.956.17 2.047c.157 2.122.274 4.435.274 6.647 0 2.212-.117 4.525-.275 6.646l-.168 2.048c-.03.328-.059.646-.09.956a8.554 8.554 0 01-7.864 7.702l-1.845.142-2.025.14-2.165.127-2.259.108c-1.935.084-3.872.128-5.81.13a138.937 138.937 0 01-5.809-.13l-2.259-.108-2.162-.128-2.025-.14-1.85-.141a8.557 8.557 0 01-7.86-7.702l-.09-.956-.17-2.048a91.573 91.573 0 01-.274-6.646c0-2.212.117-4.525.274-6.647l.17-2.047c.028-.329.058-.646.09-.956a8.555 8.555 0 017.858-7.702l1.848-.144 2.025-.137 2.164-.129 2.26-.108c1.935-.084 3.873-.127 5.81-.13zm-4.5 12.544V55.96a1.351 1.351 0 002.025 1.17l9.45-5.456a1.352 1.352 0 000-2.34l-9.45-5.454a1.35 1.35 0 00-2.025 1.168z",
    fill: "#F9B035",
    stroke: "#F9B035",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIconYellow);
export default __webpack_public_path__ + "static/media/youtube-icon-yellow.11e2c30efe607413f5ebf346e6bba77b.svg";
export { ForwardRef as ReactComponent };